import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>Výučbové prostredie na programovanie melódií prístupné pre nevidiacich žiakov ZŠ</h1>
      <p>Diplomová práca</p>
      <div className='hero-btns'>
      </div>
    </div>
  );
}

export default HeroSection;